/* RENTRASPA 11 Oct 2026 - fades a card through its colour photos every N ms (data-rs-cycle).
   Runs only while the card is on screen, pauses on hover and when the tab is hidden,
   and does nothing when the visitor prefers reduced motion. Re-scans after filter re-renders. */
(function () {
  if (window.__rsCardCycle) return;
  window.__rsCardCycle = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setup(el) {
    if (el.__rs) return;
    el.__rs = true;
    var imgs = Array.prototype.filter.call(el.children, function (c) { return c.tagName === 'IMG'; });
    if (imgs.length < 2) return;
    var st = { i: 0, visible: false, hover: false, timer: null, period: parseInt(el.getAttribute('data-rs-cycle'), 10) || 2000 };
    imgs[0].classList.add('rs-on');
    el.classList.add('rs-cycle--ready');
    function tick() {
      if (!st.visible || st.hover || document.hidden) return;
      imgs[st.i].classList.remove('rs-on');
      st.i = (st.i + 1) % imgs.length;
      imgs[st.i].classList.add('rs-on');
    }
    function start() { if (reduce || st.timer) return; st.timer = setInterval(tick, st.period); }
    function stop() { if (st.timer) { clearInterval(st.timer); st.timer = null; } }
    var card = el.closest('.card-wrapper') || el;
    card.addEventListener('mouseenter', function () { st.hover = true; });
    card.addEventListener('mouseleave', function () { st.hover = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { st.visible = e.isIntersecting; if (st.visible) start(); else stop(); });
      }, { threshold: 0.2 }).observe(el);
    } else { st.visible = true; start(); }
  }
  function scan() { document.querySelectorAll('.media.rs-cycle').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var pending = null;
  if (window.MutationObserver) {
    new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(scan, 200); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
